import { Navigate, Outlet } from "react-router-dom";
import { defaultPath } from "../../utils/constants";

const isAuthenticated = () => {
  return localStorage.getItem("accessToken");
};



const RestrictedRoute = ({ component: Component }) => {
  return !isAuthenticated() ? (Component ? <Component /> : <Outlet />) : <Navigate to={defaultPath} replace />;
};

export default RestrictedRoute;
